import React from 'react';
import LogoutButton from '../buttons/LogoutButton';
import '../../styles/topbar.css';
import { Link } from 'react-router-dom';

class TopBarMain extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const isLandingPage = window.location.pathname === '/landing';
        return (
            <div className='top-bar'>
                <div>
                    {!isLandingPage ? (
                        <Link to='/landing'>Back to Landing</Link>
                    ) : (
                        <span />
                    )}
                </div>
                <div>
                    <LogoutButton />
                </div>
            </div>
        );
    }
}

export default TopBarMain;
